<template>
  <template v-if="ismobile">
      <div :class="cssStyle" @click="showHideSidebar">
        <svg viewBox="0 0 100 80" width="22" height="30">
          <rect width="90" fill="#ffffff" height="15" rx="8"></rect>
          <rect y="32" width="90" fill="#ffffff" height="15" rx="8"></rect>
          <rect y="64" width="90" fill="#ffffff" height="15" rx="8"></rect>
        </svg>
      </div>
  </template>
  <template v-else>
      <img :src="rootPath+'assets/images/Corexpand_Logo_white.svg'" alt="AgoraCX Logo">
  </template>
</template>

<script>
    // import VTitle from 'v-title';

    export default {
        name: 'HeaderLogoHamburger',
        props: ['element','show','ismobile'],
        computed:{
            cssStyle:function () {
                if(this.ismobile){
                    return 'hamburger-white-top-left';
                }
                return 'not is mobile';
            },
            rootPath(){
              let basePath = '';
              if({}.hasOwnProperty.call(window,'rootPath')){
                basePath = window.rootPath;
              }
              return basePath;
            }
        },
      methods:{
          showHideSidebar:function (){
            this.$emit('on-show-hide-sidebar');
          }
      }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
  .hamburger-white-top-left{
    color:#fff;
  }
</style>
